<template lang="pug">
  .footer-logo
    .footer__pegi.footer-logo__item
      div
        span 16+
    .footer-logo__item(v-for="(logo, index) in logos" :key="index" )
      template(v-if="logo.link")
        a(:href="logo.link" target="_blank")
          img(:src="getSrc(logo.images)" :srcset="getSrcSet(logo.images)")
      template(v-else)
        img(:src="getSrc(logo.images)" :srcset="getSrcSet(logo.images)")
</template>
<script>
export default {
  name: "FooterLogos",
  data() {
    return {
      logos: [
        {
          images: {
            "1x": require("@static_promo_pages/common/components/footer/images/footer-logo-booming-games.svg"),
          },
        },
        {
          link: "https://my.games/",
          images: {
            "1x": require("@static_promo_pages/common/components/footer/images/footer-logo-mygames.png"),
            "2x": require("@static_promo_pages/common/components/footer/images/footer-logo-mygames@2x.png"),
          },
        },
      ],
    };
  },
  methods: {
    getSrc(image) {
      return image["1x"];
    },
    getSrcSet(image) {
      const images = image;
      let srcset = "";
      for (let size in images) {
        if (images.hasOwnProperty(size)) {
          srcset += `${images[size]} ${size},`;
        }
      }
      return srcset.substring(0, srcset.length - 1);
    },
  },
};
</script>
